const e=e=>(t,n,r)=>(t(e).each((e,i)=>{let a=t(i);r.forEach(e=>e(a,n))}),t);export{e as transformElement};
//# sourceMappingURL=transform-element.js.map